import createLane from '@/shared/aiTools/createLane.json'
import updateLane from '@/shared/aiTools/updateLane.json'
import deleteLane from '@/shared/aiTools/deleteLane.json'
import createCard from '@/shared/aiTools/createCard.json'
import updateCard from '@/shared/aiTools/updateCard.json'
import deleteCard from '@/shared/aiTools/deleteCard.json'
import createGroup from '@/shared/aiTools/createGroup.json'
import updateGroup from '@/shared/aiTools/updateGroup.json'
import deleteGroup from '@/shared/aiTools/deleteGroup.json'
import createEntities from '@/shared/aiTools/createEntities.json'
import updateEntities from '@/shared/aiTools/updateEntities.json'
import deleteEntity from '@/shared/aiTools/deleteEntity.json'
import createCommands from '@/shared/aiTools/createCommands.json'
import updateCommands from '@/shared/aiTools/updateCommands.json'
import deleteCommand from '@/shared/aiTools/deleteCommand.json'
import createDomainEventSchemas from '@/shared/aiTools/createDomainEventSchemas.json'
import updateDomainEventSchemas from '@/shared/aiTools/updateDomainEventSchemas.json'
import deleteDomainEventSchema from '@/shared/aiTools/deleteDomainEventSchema.json'
import createReadModels from '@/shared/aiTools/createReadModels.json'
import updateReadModels from '@/shared/aiTools/updateReadModels.json'
import deleteReadModel from '@/shared/aiTools/deleteReadModel.json'
import createBoundedContext from '@/shared/aiTools/createBoundedContext.json'
import updateBoundedContext from '@/shared/aiTools/updateBoundedContext.json'
import deleteBoundedContext from '@/shared/aiTools/deleteBoundedContext.json'
import addMissingCards from './addMissingCards.json'
import regenerateCards from './regenerateCards.json'
import rollbackWorkflow from './rollbackWorkflow.json'
import updateWorkflowName from './updateWorkflowName.json'
import regenerateEntities from './regenerateEntities.json'
import addMissingEntities from './addMissingEntities.json'
import regenerateCommands from './regenerateCommands.json'
import addMissingCommands from './addMissingCommands.json'
import planWorkflowWithAI from './planWorkflowWithAI.json'
import analyzeDomainModel from './analyzeDomainModel.json'
import validateDomainModel from './validateDomainModel.json'
import addMissingReadModels from './addMissingReadModels.json'
import regenerateReadModels from './regenerateReadModels.json'
import createDomainEvent from '@/shared/aiTools/createDomainEvent.json'
import updateDomainEvent from '@/shared/aiTools/updateDomainEvent.json'
import deleteDomainEvent from '@/shared/aiTools/deleteDomainEvent.json'
import addConnection from '@/shared/aiTools/addConnection.json'
import removeConnection from '@/shared/aiTools/removeConnection.json'
import generateCardsFromDescription from './generateCardsFromDescription.json'
import generateEntitiesFromDescription from './generateEntitiesFromDescription.json'
import generateCommandsFromDescription from './generateCommandsFromDescription.json'
import generateReadModelsFromDescription from './generateReadModelsFromDescription.json'
import { translateTool } from '@/ai/utils/translateTool'

const tools = [
  translateTool(createLane),
  translateTool(updateLane),
  translateTool(deleteLane),
  translateTool(createGroup),
  translateTool(updateGroup),
  translateTool(deleteGroup),
  translateTool(createCard),
  translateTool(updateCard),
  translateTool(deleteCard),
  translateTool(createDomainEvent),
  translateTool(updateDomainEvent),
  translateTool(deleteDomainEvent),
  translateTool(addConnection),
  translateTool(removeConnection),
  translateTool(createEntities),
  translateTool(updateEntities),
  translateTool(deleteEntity),
  translateTool(createCommands),
  translateTool(updateCommands),
  translateTool(deleteCommand),
  translateTool(createDomainEventSchemas),
  translateTool(updateDomainEventSchemas),
  translateTool(deleteDomainEventSchema),
  translateTool(createReadModels),
  translateTool(updateReadModels),
  translateTool(deleteReadModel),
  translateTool(createBoundedContext),
  translateTool(updateBoundedContext),
  translateTool(deleteBoundedContext),
  addMissingCards,
  regenerateCards,
  rollbackWorkflow,
  updateWorkflowName,
  regenerateEntities,
  addMissingEntities,
  regenerateCommands,
  addMissingCommands,
  planWorkflowWithAI,
  analyzeDomainModel,
  validateDomainModel,
  addMissingReadModels,
  regenerateReadModels,
  generateCardsFromDescription,
  generateEntitiesFromDescription,
  generateCommandsFromDescription,
  generateReadModelsFromDescription
]

export default tools
